import React, { useMemo } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { LoadingSkeleton } from '@atlassian/help-center-common-component/loading';
import { LinkContainer, ResultTitle } from '../common';

export const SearchResultsLoader = () => {
    const resultTitle = useMemo(
        () => (
            <ResultTitle>
                <LoadingSkeleton height={20} backgroundColor={token('color.skeleton.subtle', colors.N20)} />
            </ResultTitle>
        ),
        []
    );
    const linkContainer = useMemo(() => {
        return (
            <LinkContainer actionSubjectId="loading-link-container">
                <Box
                    xcss={xcss({
                        width: '100%',
                        overflow: 'hidden',
                        pointerEvents: 'none',
                    })}
                >
                    <LoadingSkeleton height={65} backgroundColor={token('color.skeleton.subtle', colors.N20)} />
                </Box>
            </LinkContainer>
        );
    }, []);

    return (
        <Box>
            {resultTitle}
            {linkContainer}
            {linkContainer}
            {resultTitle}
            {linkContainer}
            {linkContainer}
            {resultTitle}
            {linkContainer}
            {linkContainer}
        </Box>
    );
};
